"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// 前端h5页面用
var _info = {};
var _langs = {};
var _lang = 'en-us';

var _isDev;

function i18nInit(info) {
  _info = info;
}

; // merge 热更新的文案和本地文案

function i18nGet(langText, langType) {
  try {
    if (/^ar/.test((langType || "").toLowerCase())) {
      window.i18nArabicRTL = true;
      document.body.setAttribute("class", "".concat((document.body.getAttribute("class") || "").replace(/i18n-Arabic-rtl/g, ''), " i18n-Arabic-rtl").replace(/(^\s+|\s+$)/g, ''));
    }

    if (!window.i18nPluginH5DiffCopywriter || !langType) {
      return langText;
    }

    var langDiff = window.i18nPluginH5DiffCopywriter[langType.toLowerCase().replace("-", "_")];
    if (!langDiff) return langText;
    Object.keys(langDiff).forEach(function (key) {
      if (_info.prefix && new RegExp(_info.prefix).test(key)) {
        langDiff[key.replace(_info.prefix, "")] = langDiff[key];
        delete langDiff[key];
      }
    });

    var walk = function walk(obj, keyStr, value) {
      var keyArr = _info.noParse ? [keyStr] : keyStr.split(".");

      if (keyArr.length === 1) {
        Object.assign(obj, _defineProperty({}, keyStr, value === "[]" ? [] : value));
      } else {
        if (!obj[keyArr[0]]) obj[keyArr[0]] = {};
        Object.assign(obj[keyArr[0]], walk(obj[keyArr[0]], keyArr.slice(1).join("."), value));
      }

      return obj;
    };

    Object.keys(langDiff).map(function (keyStr) {
      walk(langText, keyStr, langDiff[keyStr]);
    });
  } catch (e) {
    console.log('i18n-plugin-error:', e);
  }

  return langText;
}

; // 热更新用

function i18nLoading(errCallback) {
  return new Promise(function (resolve) {
    var retryCount = 1;
    var interval = setInterval(function () {
      if (window.i18nPluginH5DiffCopywriterLoaded) {
        clearInterval(interval);

        if (window.i18nPluginH5DiffCopywriterLoaded !== "success") {
          errCallback(window.i18nPluginH5DiffCopywriterLoaded);
        }

        resolve();
      } else {
        retryCount++;
        window.loadTime = retryCount * 100 + 100;

        if (retryCount >= 100) {
          clearInterval(interval);
          errCallback("timeout");
          resolve();
        }
      }
    }, 100);
  });
}

;
module.exports.i18nInit = i18nInit;
module.exports.i18nGet = i18nGet;
module.exports.i18nLoading = i18nLoading; // 见文档 http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=294732154

module.exports.i18nStart = function (entry, info, langs) {
  i18nInit(info);
  _langs = entry;
  _isDev = !!langs;
  if (!_isDev) return;
  var failedLangs = [];
  langs.forEach(function (lang, i) {
    lang = lang.replace('_', '-').toLowerCase();
    if (!i) _lang = lang;

    if (!entry[lang]) {
      failedLangs.push(lang);
    }
  });
  failedLangs.length && fetch('http://localhost:12122?langs=' + failedLangs.join(','));
};

module.exports.i18nSetLang = function (lang) {
  _lang = lang.replace('_', '-').toLowerCase();

  if (/^ar/.test(_lang)) {
    window.i18nArabicRTL = true;
    document.body.setAttribute("class", "".concat((document.body.getAttribute("class") || "").replace(/i18n-Arabic-rtl/g, ''), " i18n-Arabic-rtl").replace(/(^\s+|\s+$)/g, ''));
  }

  _isDev && !_langs[_lang] && fetch('http://localhost:12122?langs=' + _lang);
};

module.exports.i18nTranslate = function (key, data) {
  var text = i18nGet(_langs[_lang]["default"] || _langs[_lang], _lang)[key];

  if (text) {
    // 替换占位符   i18nTranslate('hfieahfaoefj{{d1}}feafa{{d2}}', {d1: '1', d2:'2'})
    return _typeof(data) === "object" ? text.replace(new RegExp("(" + Object.keys(data).map(function (k) {
      return "{{\\s*".concat(k, "\\s*}}");
    }).join("|") + ")", "g"), function (v) {
      return data[v.slice(2, -2).replace(/(^\s+|\s+$)/g, "")];
    }) : text;
  } else {
    _isDev && fetch('http://localhost:12122?keys=' + key);
  }
};